import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const BasketPageTitleSkeleton = () => {
  return <SkeletonBlock $width="100%" $height="3rem" />;
};
